/* eslint-disable vue/multi-word-component-names */
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import Notifications from 'vue-notification';
import VueTheMask from 'vue-the-mask';
import App from './App.vue';
import excel from 'vue-excel-export';

import router from './router';
import store from './store';
const momentTimezone = require('moment-timezone');

Vue.component('multiselect', Multiselect);

Vue.filter('CPF', function (documentId, documentType) {
  documentId = typeof documentId != 'string' ? documentId.toString() : documentId;
  if (documentType == 'J') {
    documentId = documentId.padStart(14, '0');
    documentId = documentId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    documentId = documentId.padStart(11, '0');
    documentId = documentId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  return documentId;
});

Vue.filter('PHONE', function (phone) {
  phone = phone.toString();
  phone = phone.replace('+55', '');
  if (phone.substring(0, 2) == ' 5') {
    phone = phone.substring(3);
  }
  phone = phone.replace(/^(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');

  return phone;
});

Vue.filter('TIME', function (minute) {
  var hours = Math.floor(minute / 60);
  var minutes = Math.floor(minute % 60);
  var seconds = Math.floor((minute * 60) % 60);
  return hours + 'h ' + minutes + 'min ' + seconds + 's';
});

Vue.filter('AGE', function (date) {
  var diff = moment(date).diff(moment(), 'milliseconds');
  var duration = moment.duration(diff);
  var years = duration.years();
  return years * -1;
});

Vue.filter('firstName', function (name) {
  return name.split(' ')[0];
});

Vue.filter('camelCase', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('formatDateUtc', function (value) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!value) return '';
  return momentTimezone.utc(value, 'DD/MM/YYYY HH:mm').tz(timezone).format('DD/MM/YY HH:mm');
});

Vue.config.productionTip = false;

const moment = require('moment');
require('moment/locale/pt-br');

Vue.use(require('vue-moment'), {
  moment,
});

Vue.use(excel);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueTheMask);
Vue.use(Notifications);

Vue.config.errorHandler = (error) => console.log(error);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
